export const INVOICE_SET_ELEMENTS = 'INVOICE_SET_ELEMENTS';

export const INVOICE_CLEAR_ELEMENTS = 'INVOICE_CLEAR_ELEMENTS';

export const INVOICE_SET_DETAILS = 'INVOICE_SET_DETAILS';